// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1ARVP","info":"Note_info__3lKSd","note":"Note_note__FC3Aa","actions":"Note_actions__1Ky1i"};